import { render, staticRenderFns } from "./cancelamento-cartao.vue?vue&type=template&id=05a8e55d&"
import script from "./cancelamento-cartao.vue?vue&type=script&lang=js&"
export * from "./cancelamento-cartao.vue?vue&type=script&lang=js&"
import style0 from "./cancelamento-cartao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports